import classNames from 'classnames';
import '../FilterMenu.scss';
import React, { Children, isValidElement, ReactElement } from 'react';
import { Dropdown } from 'react-bootstrap';

interface FilterDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  align?: 'start' | 'end';
}

interface FilterDropdownSubProps extends React.HTMLAttributes<HTMLDivElement> {}

const FilterDropdown: React.FC<FilterDropdownProps> & {
  Toggle: React.FC<FilterDropdownSubProps>;
  Menu: React.FC<FilterDropdownSubProps>;
} = ({ label, align, children, className }) => {
  const childArray = Children.toArray(children);

  const toggle = childArray.find(child => isValidElement(child) && child.type === FilterDropdownToggle) as
    | ReactElement<FilterDropdownSubProps>
    | undefined;

  const menu = childArray.find(child => isValidElement(child) && child.type === FilterDropdownMenu) as
    | ReactElement<FilterDropdownSubProps>
    | undefined;

  return (
    <Dropdown className={classNames('filter-dropdown-container h-100', className)} align={align}>
      <Dropdown.Toggle
        variant="outline-light"
        className="filter-dropdown h-100 text-body border-0 rounded-pill text-start fw-normal px-4 py-2">
        <p className="m-0 fw-bold text-muted small">{label}</p>
        <div className={classNames('m-0 text-truncate', toggle?.props.className)}>{toggle?.props.children}</div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={classNames('filter-dropdown-menu rounded-5 p-4', menu?.props.className)}>
        {menu?.props.children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const FilterDropdownToggle: React.FC<FilterDropdownSubProps> = () => null;
FilterDropdown.Toggle = FilterDropdownToggle;

const FilterDropdownMenu: React.FC<FilterDropdownSubProps> = () => null;
FilterDropdown.Menu = FilterDropdownMenu;

export default FilterDropdown;
